import React from 'react';
import PropTypes from 'prop-types';

export const WidgetTypes = {
  plain: 'plain',
  withIcon: 'withIcon',
  colorfullWithIcon: 'colorfullWithIcon',
  mobileTooltip: 'mobileTooltip',
};

function ReadingsWidget(props) {
  const {
    icon,
    title,
    value,
    subtitle,
    color,
    alerted,
    selected,
    type,
    onClick,
    valueTooltip,
    isCollapsible,
    expanded,
    config,
  } = props;
  
  const titleRef = React.useRef(null);
  const showTooltip = titleRef.current?.scrollWidth > titleRef.current?.clientWidth;
  return (
    <>
      {type === WidgetTypes.plain && (
        <div
          className={`grid-readings-cell
          ${selected ? 'selected' : ''}
          ${alerted ? ' alerted' : ''}
          ${onClick ? '' : ' notClickable'}`}
          style={config?.backgroundColor?.value ? { backgroundColor: config.backgroundColor?.value } : {}}
          onClick={onClick}
        >
          <div
            data-tooltip-content={title}
            data-tooltip-id={showTooltip ? 'tooltip' : undefined}
            className="cell-el title"
            style={config?.titleColor?.value ? { color: config.titleColor?.value } : {}}
            ref={titleRef}
          >
            {title}
          </div>
          <div
            className="cell-el value"
            style={{
              ...config?.valueColor?.value ? { color: config.valueColor?.value } : {},
              ...valueTooltip ? { pointerEvents: 'auto' } : {}
            }}
            data-tooltip-content={valueTooltip}
            data-tooltip-id={valueTooltip ? 'tooltip' : undefined}
            data-tooltip-place="bottom"
            data-testid={`widget[${title}].value`}
          >
            {value}
          </div>
          {subtitle && <div className="cell-el subtitle">{subtitle}</div>}
        </div>
      )}
      {type === WidgetTypes.withIcon && (
        <div
          className={`widget-with-icon grey
          ${(!isCollapsible && selected) || (isCollapsible && expanded) ? 'selected' : ''}
        ${alerted ? ' alerted' : ''}
        ${onClick ? ' clickable' : ''}`}
          onClick={onClick}
        >
          <div className={`icon-container`}>
            <div className={`widget-icon ${icon}`} />
          </div>
          <div className="data">
            <div
              data-tooltip-content={title}
              data-tooltip-id={showTooltip ? 'tooltip' : undefined}
              className="cell-el title"
              ref={titleRef}
            >
              {title}
            </div>
            <div
              className="cell-el value"
              style={valueTooltip ? { pointerEvents: 'auto' } : {}}
              data-tooltip-content={valueTooltip}
              data-tooltip-id={valueTooltip ? 'tooltip' : undefined}
              data-tooltip-place="bottom"
              data-testid={`widget[${title}].value`}
            >
              {value}
            </div>
            {subtitle && <div className="cell-el subtitle">{subtitle}</div>}
          </div>
          {isCollapsible && <div className={`collapse-icon ${expanded ? '' : 'collapsed'}`} />}
        </div>
      )}
      {type === WidgetTypes.colorfullWithIcon && (
        <div
          className={`widget-with-icon ${
            (!isCollapsible && selected) || (isCollapsible && expanded) ? 'selected' : ''
          }${onClick ? ' clickable' : ''}`}
          onClick={onClick}
        >
          <div className={`icon-container ${color || (alerted ? 'pink' : 'green')}`}>
            <div className={`widget-icon ${icon}`} />
          </div>
          <div className="data">
            <div
              data-tooltip-content={title}
              data-tooltip-id={showTooltip ? 'tooltip' : undefined}
              className="cell-el title"
              ref={titleRef}
            >
              {title}
            </div>
            <div
              className="cell-el value"
              style={valueTooltip ? { pointerEvents: 'auto' } : {}}
              data-tooltip-content={valueTooltip}
              data-tooltip-id={valueTooltip ? 'tooltip' : undefined}
              data-tooltip-place="bottom"
            >
              {value}
            </div>
            {subtitle && <div className="cell-el subtitle">{subtitle}</div>}
          </div>
          {isCollapsible && <div className={`collapse-icon ${expanded ? '' : 'collapsed'}`} />}
        </div>
      )}
      {type === WidgetTypes.mobileTooltip && (
        <div className={`grid-readings-cell notClickable left-aligned ${alerted ? ' alerted' : ''} `}>
          <div className="cell-el title" ref={titleRef}>
            {title}
          </div>
          <div className="cell-el value">{value}</div>
          {subtitle && <div className="cell-el subtitle">{subtitle}</div>}
        </div>
      )}
    </>
  );
};

ReadingsWidget.propTypes = {
  icon: PropTypes.string,
  color: PropTypes.string,
  title: PropTypes.any.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  subtitle: PropTypes.node,
  type: PropTypes.oneOf(Object.values(WidgetTypes)),
  alerted: PropTypes.bool,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
  valueTooltip: PropTypes.string,
  isCollapsible: PropTypes.bool,
  expanded: PropTypes.bool,
  config: PropTypes.object,
};

export default ReadingsWidget;
